import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 19.5v3m0-21v3M6.697 17.304l-2.122 2.12m14.85-14.849l-2.122 2.121M4.5 12h-3m21 0h-3M6.697 6.696l-2.122-2.12m14.85 14.849l-2.122-2.121M17.25 12a5.25 5.25 0 11-10.501-.001A5.25 5.25 0 0117.25 12z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 19.5v3m0-21v3M6.697 17.304l-2.122 2.12m14.85-14.849l-2.122 2.121M4.5 12h-3m21 0h-3M6.697 6.696l-2.122-2.12m14.85 14.849l-2.122-2.121M17.25 12a5.25 5.25 0 11-10.501-.001A5.25 5.25 0 0117.25 12z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 39v6m0-42v6M13.394 34.607L9.15 38.85m29.7-29.7l-4.244 4.242M9 24H3m42 0h-6M13.394 13.393L9.15 9.15m29.7 29.699l-4.244-4.242M34.5 24c0 5.798-4.702 10.5-10.5 10.5S13.5 29.798 13.5 24 18.202 13.5 24 13.5 34.5 18.202 34.5 24z"
  }))
};
export var WeatherSunny = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});